import { render, staticRenderFns } from "./EnterpriseRusesTabComponent.vue?vue&type=template&id=387dd7a6&scoped=true"
import script from "./EnterpriseRusesTabComponent.js?vue&type=script&lang=js&external"
export * from "./EnterpriseRusesTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./EnterpriseRusesTabComponent.vue?vue&type=style&index=0&id=387dd7a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387dd7a6",
  null
  
)

export default component.exports